var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',{staticClass:"a-label ds",attrs:{"for":_vm.forId}},[_vm._t("default"),(_vm.optional)?[_c('span',{staticClass:"a-label__optional"},[_vm._v(" ("+_vm._s(_vm.optionalIndicator)+") ")])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }